import { Button } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { Campaign } from '@features/campaigns';
import { dateFormat } from '@utils/utils';
import { AccountManager } from './AccountManager/AccountManager';
import { ArchiveToggle, ArchiveToggleProps } from './ArchiveToggle';
import { ReportStatusIcon } from '@components/Stats/campaign/ReportStatusIcon';

export type ColumnsOptions = {
  onClickManageCampaign: (campaign: Campaign) => void;
  updateCampaign: ArchiveToggleProps['updateCampaign'];
};

export const columns = (options: ColumnsOptions): GridColDef<Campaign>[] => [
  {
    field: 'id',
    headerName: 'ID',
    display: 'flex',
    flex: 0.5,
  },
  {
    field: 'latestReportStatus',
    headerName: 'Latest Report Status',
    display: 'flex',
    flex: 0.5,
    renderCell: params => (
      <ReportStatusIcon latestReportStatus={params.row.latestReportStatus} />
    ),
  },
  {
    field: 'archived',
    headerName: 'Archived',
    display: 'flex',
    flex: 0.5,
    renderCell: params => (
      <ArchiveToggle
        campaignId={params.row.id}
        archived={params.row.archived}
        updateCampaign={options.updateCampaign}
      />
    ),
  },
  {
    field: 'name',
    headerName: 'Campaign Name',
    display: 'flex',
    flex: 1.5,
  },
  {
    field: 'advertiserName',
    headerName: 'Organization',
    display: 'flex',
    flex: 1,
  },
  {
    field: 'advertiserTeamName',
    headerName: 'Advertiser',
    display: 'flex',
    flex: 1,
  },
  {
    field: 'accountManager',
    headerName: 'Account Manager',
    display: 'flex',
    flex: 1.5,
    renderCell: params => <AccountManager campaign={params.row} />,
  },
  {
    field: 'startDate',
    headerName: 'Start Date',
    display: 'flex',
    flex: 0.5,
    valueFormatter: (value: Campaign['startDate']) =>
      dateFormat(new Date(value)),
  },
  {
    field: 'endDate',
    headerName: 'End Date',
    display: 'flex',
    flex: 0.5,
    valueFormatter: (value: Campaign['startDate']) =>
      dateFormat(new Date(value)),
  },
  {
    headerName: 'Actions',
    field: 'actions',
    display: 'flex',
    flex: 1,
    sortable: false,
    type: 'actions',
    getActions: params => {
      return [
        <Button
          key="manage-campaign-btn"
          onClick={() => options.onClickManageCampaign(params.row)}
        >
          Manage Reports
        </Button>,
      ];
    },
  },
];
